import React from 'react';
import CenteredPageContainer from "../../common/centeredcontainer/centered-page-container";
import Curriculum from "./curriculum/curriculum";
import DaySchedule from "./day-schedule/day-schedule";
import HeroBannerV2 from "../banner/v2/regular-left-right/hero-banner-v2";
import FooterXsci from "../../common/footer/footer-xsci";
import Evaluation from "./evaluation/evaluation";
import NavBar from "../../v2/layout/navigation/navBar";
import HeroBanner from "../../v2/layout/banner/HeroBanner";


const Program: React.FC = () => {

    const title = "Un curriculum adapté a chaque enfant, leur age et leur besoin "


    return (
        <>
            <NavBar />

            {/*<HeroBanner*/}
            {/*    backgroundImageUrl={"/images/programs/learning.jpg"}*/}
            {/*    title= {"Un curriculum adaptee\n" +*/}
            {/*        "a chaque enfant,\n" +*/}
            {/*        "leur age et leur besoin."}*/}
            {/*/>*/}
            {/*<HeroBannerV2*/}
            {/*    coloredTitle={[*/}
            {/*        { text: title, color: '#327CCD' },*/}
            {/*    ]}*/}
            {/*    showButton*/}
            {/*    backgroundImageUrl={"/images/programs/learning.jpg"}*/}
            {/*/>*/}
            <HeroBanner
                title={"Nos Programmes d'Apprentissage Éducatif"}
                subTitle={"Un curriculum adapté à chaque enfant, selon leurs âges et leurs besoins"}
                imageUrl={"images/programs/banner.jpg"}
                hideCta={false}/>
            <CenteredPageContainer component={() => (
                <>
                    <Curriculum/>
                    <DaySchedule/>
                    <Evaluation/>
                    <FooterXsci/>
                </>
            )} />

        </>
    );
};

export default Program;
